import React from "react";
import MatterAiPane from "../MatterAi/MatterAiPane";

const FullScopeAiPage = ({ match }) => {
	return (
		<div className="noDefaultMargin searchFullHeightDefault">
			<div>
				<MatterAiPane
					sessionId={match?.params?.sessionId}
					basePath="/ai"
					fullScope
				/>
			</div>
		</div>
	);
};

export default FullScopeAiPage;
